module.exports = __webpack_public_path__ + "c78b6f8f.svg";